module.exports = __webpack_public_path__ + "img/vijaysales.a41ffcb6.svg";